<template>
  <li class="message_item">
    <div class="msg_date_wrp">
      <span class="msg_date_box">{{ label }}</span>
    </div>
  </li>
</template>

<script>
export default {
  name: 'ChatDateSeparator',

  props: {
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.message_item {
  clear: both;
  float: left;
  margin: 5px 0;
  width: 100%;
  font-size: 13px;
}



.msg_date_wrp {
    text-align: center;
    margin: 10px 0px 15px !important;
    position: relative;

    &::before {
        content: "";
        height: 1px;
        position: absolute;
        left: -5px;
        right: -5px;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        backdrop-filter: blur(165px);
        background: linear-gradient(90deg, rgba(0, 140, 255, 0.8) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 78, 205, 0.8) 100%);
        opacity: 0.9;
        filter: blur(2px);
    }

    span {
        &.msg_date_box {
            background: #ffc107;
            color: #000;
            border-radius: 3px;
            padding: 2px 6px;
            font-weight: 500;
            font-size: 15px;
            line-height: 1;
            position: relative;
            background: linear-gradient(135deg, #ffc400, #ff8c00);
            box-shadow: 0 0 10px rgba(255, 196, 0, 0.7);
        }
    }
}

</style>
